﻿import { qs, on } from "../core/dom";

export function initHeader() {
    const header = qs(".site-header");

    if (!header) return;

    const handleScroll = () => {
        const isScrolled = window.scrollY > 10;
        header.classList.toggle("is-scrolled", isScrolled);
    };

    handleScroll();
    on(window, "scroll", handleScroll);
}